<script setup lang="ts">
import { computed, onMounted, onUnmounted, watch } from "vue";
import OffsetChartComponent from "@/modules/booking_experts/pages/Components/Chart/OffsetChartComponent.vue";
import { useApiClient } from "@/api/client";
import router from "@/router/router";
import { useRoute } from "vue-router";
import { useCurveModelStore } from "@/modules/booking_experts/store";

const api = useApiClient("bookingExperts");
const store = useCurveModelStore();
const route = useRoute();

const loading = computed(() => store.currentCurve === undefined);

const loadCurve = async (id: number) => {
	if (Number.isNaN(id)) {
		await router.push("/404");
		return;
	}

	store.currentCurve = undefined;
	store.showPY = store.showCY = false;
	const [curveData, priceListsData] = await Promise.all([
		api.getPriceModelCurve(id),
		api.getMasterPrices(),
	]);

	if (curveData.isOk() && priceListsData.isOk()) {
		store.currentCurve = curveData.value;
		store.priceLists = priceListsData.value;
		store.currentBreadcrumb = curveData.value.name;
	}
};

onMounted(() => loadCurve(Number(route.params.id)));

watch(() => route.params.id, (id) => loadCurve(Number(id)));

onUnmounted(() => {
	store.currentCurve = undefined;
	store.referenceData.y0 = store.referenceData.y1 = [];
	store.currentBreadcrumb = null;
});
</script>

<template>
	<v-overlay :model-value="loading" class="align-center justify-center">
		<v-progress-circular color="primary" size="64" indeterminate />
	</v-overlay>
	<div class="mt-5">
		<OffsetChartComponent v-if="!loading" />
	</div>
</template>

<style scoped lang="scss"></style>
